import { createReducer, on } from '@ngrx/store'
import { DebidaDiligenciaInterface } from '@shared/interfaces/app.state.interfaces'
import { debidaDiligencia } from '../actions/debida-diligencia.actions'

export const initialState: DebidaDiligenciaInterface = { estado: '' }

export const debidaDiligenciaReducer = createReducer(
    initialState,
    on(debidaDiligencia, ((state, { item }) => {
        return { ...state, estado: item.estado }
    }))
)